export default __webpack_public_path__ + "static/media/instagram.fa7514f4.svg";